module.exports = __webpack_public_path__ + "static/img/ic_logo_actv.29db09e7.png";